/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AberturaPorCreditoResponse,
  AberturaPorCupomResponse,
  AbrirPorCupomDto,
  DefinirPrecoDto,
  ErroResponse,
  IniciarPagamentoDto,
  PagamentoResponse,
  PrecoDiscussaoResponse,
  PrecoVigenteAdminResponse,
  PreviaCupomResponse,
  ValidarCupomDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPagamentosControllerIniciarUrl = (id: string,) => {




  return `/v1/discussoes/${id}/pagamento`
}

/**
 * @summary Inicia (ou retenta) a cobrança de um rascunho de discussão — Pix ou cartão à vista
 */
export const pagamentosControllerIniciar = async (id: string,
    iniciarPagamentoDto: IniciarPagamentoDto, options?: Parameters<typeof httpClient>[1]): Promise<PagamentoResponse> => {

  return httpClient<PagamentoResponse>(getPagamentosControllerIniciarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(iniciarPagamentoDto)
  }
);}





export const getPagamentosControllerIniciarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerIniciar>>, TError,{id: string;data: IniciarPagamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerIniciar>>, TError,{id: string;data: IniciarPagamentoDto}, TContext> => {

const mutationKey = ['pagamentosControllerIniciar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pagamentosControllerIniciar>>, {id: string;data: IniciarPagamentoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  pagamentosControllerIniciar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PagamentosControllerIniciarMutationResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerIniciar>>>
    export type PagamentosControllerIniciarMutationBody = IniciarPagamentoDto
    export type PagamentosControllerIniciarMutationError = ErroResponse

    /**
 * @summary Inicia (ou retenta) a cobrança de um rascunho de discussão — Pix ou cartão à vista
 */
export const usePagamentosControllerIniciar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerIniciar>>, TError,{id: string;data: IniciarPagamentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pagamentosControllerIniciar>>,
        TError,
        {id: string;data: IniciarPagamentoDto},
        TContext
      > => {
      return useMutation(getPagamentosControllerIniciarMutationOptions(options), queryClient);
    }
    export const getPagamentosControllerStatusUrl = (id: string,) => {




  return `/v1/discussoes/${id}/pagamento`
}

/**
 * @summary Status da cobrança mais recente da discussão — pra dar polling enquanto aguarda o Pix cair
 */
export const pagamentosControllerStatus = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<PagamentoResponse> => {

  return httpClient<PagamentoResponse>(getPagamentosControllerStatusUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPagamentosControllerStatusQueryKey = (id: string,) => {
    return [
    `/v1/discussoes/${id}/pagamento`
    ] as const;
    }


export const getPagamentosControllerStatusQueryOptions = <TData = Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagamentosControllerStatusQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagamentosControllerStatus>>> = ({ signal }) => pagamentosControllerStatus(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagamentosControllerStatusQueryResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerStatus>>>
export type PagamentosControllerStatusQueryError = ErroResponse


export function usePagamentosControllerStatus<TData = Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagamentosControllerStatus>>,
          TError,
          Awaited<ReturnType<typeof pagamentosControllerStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagamentosControllerStatus<TData = Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagamentosControllerStatus>>,
          TError,
          Awaited<ReturnType<typeof pagamentosControllerStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagamentosControllerStatus<TData = Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Status da cobrança mais recente da discussão — pra dar polling enquanto aguarda o Pix cair
 */

export function usePagamentosControllerStatus<TData = Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerStatus>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagamentosControllerStatusQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPagamentosControllerAbrirComCreditoUrl = (id: string,) => {




  return `/v1/discussoes/${id}/abertura-por-credito`
}

/**
 * @summary Abre o rascunho consumindo 1 crédito de discussão do autor, sem cobrança
 */
export const pagamentosControllerAbrirComCredito = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<AberturaPorCreditoResponse> => {

  return httpClient<AberturaPorCreditoResponse>(getPagamentosControllerAbrirComCreditoUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPagamentosControllerAbrirComCreditoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerAbrirComCredito>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerAbrirComCredito>>, TError,{id: string}, TContext> => {

const mutationKey = ['pagamentosControllerAbrirComCredito'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pagamentosControllerAbrirComCredito>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pagamentosControllerAbrirComCredito(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PagamentosControllerAbrirComCreditoMutationResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerAbrirComCredito>>>

    export type PagamentosControllerAbrirComCreditoMutationError = ErroResponse

    /**
 * @summary Abre o rascunho consumindo 1 crédito de discussão do autor, sem cobrança
 */
export const usePagamentosControllerAbrirComCredito = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerAbrirComCredito>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pagamentosControllerAbrirComCredito>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPagamentosControllerAbrirComCreditoMutationOptions(options), queryClient);
    }
    export const getPagamentosControllerValidarCupomUrl = (id: string,) => {




  return `/v1/discussoes/${id}/cupom/validar`
}

/**
 * @summary Confere um código de cupom e devolve o valor com desconto — NÃO consome o uso
 */
export const pagamentosControllerValidarCupom = async (id: string,
    validarCupomDto: ValidarCupomDto, options?: Parameters<typeof httpClient>[1]): Promise<PreviaCupomResponse> => {

  return httpClient<PreviaCupomResponse>(getPagamentosControllerValidarCupomUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(validarCupomDto)
  }
);}





export const getPagamentosControllerValidarCupomMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerValidarCupom>>, TError,{id: string;data: ValidarCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerValidarCupom>>, TError,{id: string;data: ValidarCupomDto}, TContext> => {

const mutationKey = ['pagamentosControllerValidarCupom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pagamentosControllerValidarCupom>>, {id: string;data: ValidarCupomDto}> = (props) => {
          const {id,data} = props ?? {};

          return  pagamentosControllerValidarCupom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PagamentosControllerValidarCupomMutationResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerValidarCupom>>>
    export type PagamentosControllerValidarCupomMutationBody = ValidarCupomDto
    export type PagamentosControllerValidarCupomMutationError = ErroResponse

    /**
 * @summary Confere um código de cupom e devolve o valor com desconto — NÃO consome o uso
 */
export const usePagamentosControllerValidarCupom = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerValidarCupom>>, TError,{id: string;data: ValidarCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pagamentosControllerValidarCupom>>,
        TError,
        {id: string;data: ValidarCupomDto},
        TContext
      > => {
      return useMutation(getPagamentosControllerValidarCupomMutationOptions(options), queryClient);
    }
    export const getPagamentosControllerAbrirComCupomUrl = (id: string,) => {




  return `/v1/discussoes/${id}/abertura-por-cupom`
}

/**
 * @summary Abre o rascunho com um cupom de 100% de desconto, sem cobrança
 */
export const pagamentosControllerAbrirComCupom = async (id: string,
    abrirPorCupomDto: AbrirPorCupomDto, options?: Parameters<typeof httpClient>[1]): Promise<AberturaPorCupomResponse> => {

  return httpClient<AberturaPorCupomResponse>(getPagamentosControllerAbrirComCupomUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(abrirPorCupomDto)
  }
);}





export const getPagamentosControllerAbrirComCupomMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerAbrirComCupom>>, TError,{id: string;data: AbrirPorCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerAbrirComCupom>>, TError,{id: string;data: AbrirPorCupomDto}, TContext> => {

const mutationKey = ['pagamentosControllerAbrirComCupom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pagamentosControllerAbrirComCupom>>, {id: string;data: AbrirPorCupomDto}> = (props) => {
          const {id,data} = props ?? {};

          return  pagamentosControllerAbrirComCupom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PagamentosControllerAbrirComCupomMutationResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerAbrirComCupom>>>
    export type PagamentosControllerAbrirComCupomMutationBody = AbrirPorCupomDto
    export type PagamentosControllerAbrirComCupomMutationError = ErroResponse

    /**
 * @summary Abre o rascunho com um cupom de 100% de desconto, sem cobrança
 */
export const usePagamentosControllerAbrirComCupom = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerAbrirComCupom>>, TError,{id: string;data: AbrirPorCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pagamentosControllerAbrirComCupom>>,
        TError,
        {id: string;data: AbrirPorCupomDto},
        TContext
      > => {
      return useMutation(getPagamentosControllerAbrirComCupomMutationOptions(options), queryClient);
    }
    export const getPagamentosControllerObterPrecoUrl = () => {




  return `/v1/admin/precos-discussao`
}

/**
 * @summary Preço vigente da discussão — `preco: null` enquanto nenhum foi configurado
 */
export const pagamentosControllerObterPreco = async ( options?: Parameters<typeof httpClient>[1]): Promise<PrecoVigenteAdminResponse> => {

  return httpClient<PrecoVigenteAdminResponse>(getPagamentosControllerObterPrecoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPagamentosControllerObterPrecoQueryKey = () => {
    return [
    `/v1/admin/precos-discussao`
    ] as const;
    }


export const getPagamentosControllerObterPrecoQueryOptions = <TData = Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPagamentosControllerObterPrecoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>> = ({ signal }) => pagamentosControllerObterPreco({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PagamentosControllerObterPrecoQueryResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>>
export type PagamentosControllerObterPrecoQueryError = unknown


export function usePagamentosControllerObterPreco<TData = Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagamentosControllerObterPreco>>,
          TError,
          Awaited<ReturnType<typeof pagamentosControllerObterPreco>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagamentosControllerObterPreco<TData = Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pagamentosControllerObterPreco>>,
          TError,
          Awaited<ReturnType<typeof pagamentosControllerObterPreco>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePagamentosControllerObterPreco<TData = Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preço vigente da discussão — `preco: null` enquanto nenhum foi configurado
 */

export function usePagamentosControllerObterPreco<TData = Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pagamentosControllerObterPreco>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPagamentosControllerObterPrecoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPagamentosControllerDefinirPrecoUrl = () => {




  return `/v1/admin/precos-discussao`
}

/**
 * @summary Define o novo preço vigente da discussão. Nunca sobrescreve — insere uma linha nova no histórico.
 */
export const pagamentosControllerDefinirPreco = async (definirPrecoDto: DefinirPrecoDto, options?: Parameters<typeof httpClient>[1]): Promise<PrecoDiscussaoResponse> => {

  return httpClient<PrecoDiscussaoResponse>(getPagamentosControllerDefinirPrecoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirPrecoDto)
  }
);}





export const getPagamentosControllerDefinirPrecoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerDefinirPreco>>, TError,{data: DefinirPrecoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerDefinirPreco>>, TError,{data: DefinirPrecoDto}, TContext> => {

const mutationKey = ['pagamentosControllerDefinirPreco'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pagamentosControllerDefinirPreco>>, {data: DefinirPrecoDto}> = (props) => {
          const {data} = props ?? {};

          return  pagamentosControllerDefinirPreco(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PagamentosControllerDefinirPrecoMutationResult = NonNullable<Awaited<ReturnType<typeof pagamentosControllerDefinirPreco>>>
    export type PagamentosControllerDefinirPrecoMutationBody = DefinirPrecoDto
    export type PagamentosControllerDefinirPrecoMutationError = unknown

    /**
 * @summary Define o novo preço vigente da discussão. Nunca sobrescreve — insere uma linha nova no histórico.
 */
export const usePagamentosControllerDefinirPreco = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pagamentosControllerDefinirPreco>>, TError,{data: DefinirPrecoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pagamentosControllerDefinirPreco>>,
        TError,
        {data: DefinirPrecoDto},
        TContext
      > => {
      return useMutation(getPagamentosControllerDefinirPrecoMutationOptions(options), queryClient);
    }
